module.exports = __webpack_public_path__ + "img/logo.304e2ce1.png";